<template>
  <div class="swiper-main">
    <div class="swiper-container1">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="slide in slides" :key="slide.id" :data-id="slide.id">
          <img loading="lazy"  :src="slide.img"
            class="img" alt=""
            @click="slideClickEvent(slide.id, slides)"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut">
          <div class="lable">
            <div class="num">{{slide.id}}/{{slides.length}}</div>
          </div>
        </div>
      </div>
      <div class="next common" ref="nextBtn" @mouseover="handleMouseOver" @mouseout="handleMouseOut">
        <img loading="lazy"  :src="next" alt="">
      </div>
      <div class="prev common" ref="prevBtn" @mouseover="handleMouseOver" @mouseout="handleMouseOut">
        <img loading="lazy"  :src="prev" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
import next from '/static/img/newProductDetils/left1.png'
import prev from '/static/img/newProductDetils/right1.png'
import left from '/static/img/newProductDetils/black-left.png'
import right from '/static/img/newProductDetils/black-right.png'

export default {
  props: {
    swiperList: Array,
  },
  data() {
    return {
      slides: [],
      swiper: null,
      next: next,
      prev: prev,
      left: left,
      right: right
    }
  },
  mounted() {
    this.initSwiper()
    // if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)) {//判断是不是手机
    //     this.$refs.nextBtn.style.opacity = 1
    //     this.$refs.prevBtn.style.opacity = 1
    // }
  },
  watch: {
    swiperList: {
      handler(newVal) {
        this.slides = newVal
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    slideClickEvent(id, slides) {
      this.$emit('childSlideEvent', id, slides)
    },
    initSwiper() {
      this.swiper = new Swiper('.swiper-container1', {
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        spaceBetween: 30,
        keyboardControl: true,
        nextButton: '.prev',
        prevButton: '.next',
        autoplay: 3000,
      })
    },
    handleMouseOver() {
      // 显示按钮
      this.$refs.nextBtn.style.opacity = 1
      this.$refs.prevBtn.style.opacity = 1
    },
    handleMouseOut() {
      // 隐藏按钮
      this.$refs.nextBtn.style.opacity = 0
      this.$refs.prevBtn.style.opacity = 0
    },
  },
}
</script>

<style scoped lang="scss">
@import '/style/phone/productDetailsSwiper/loopSwiper/loopSwiper.scss';
.swiper-main {
  width: 100%;
  overflow: hidden;
}

.swiper-container1 {
  width: 100%;
  height: 33.125rem;
  position: relative;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  .img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 0.5rem;
  }
}

.common {
  width: 2.5625rem;
  height: 2.5625rem;
  position: absolute;
  z-index: 99;
  bottom: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  img {
    display: block;
    width: 35%;
    height: 35%;
  }
  transition: opacity 0.3s ease;  /* 添加过渡效果 */
}

.next {
  left: 1.25rem;
  cursor: pointer;
  opacity: 0;  /* 默认隐藏 */
}

.prev {
  right: 1.25rem;
  cursor: pointer;
  opacity: 0;  /* 默认隐藏 */
}

.swiper-button-disabled {
  background: rgba(255, 255, 255, 0.3);
}

.lable {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 99;
  display: flex;
  background: rgba(255, 255, 255, 0.70);
  padding: 0.75rem 1rem;
  justify-content: space-around;
  align-items: center;
  color: #191919;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: Inter;

  img {
    display: block;
    width: 1rem;
    height: 1rem;
  }
}
</style>
